import { get } from 'lodash';
import logo from 'components/Article/logo.png';
import defaults, { DefaultsInterface } from 'lib/StructuredData/defaults';
import StructuredDataInterface from './types';
// assets

type SlideshowStructuredData = StructuredDataInterface & DefaultsInterface;

class Slideshow {
  image: string;

  description: string;

  title: string;

  author: { name?: string };

  publicationDate: string;

  url: string;

  constructor({
    coverSlide,
    publicationDate,
    metaDescription: description,
    title,
    author = {},
    slideshowUrl: url,
  }: {
    coverSlide: Record<string, any>;
    publicationDate: string;
    metaDescription: string;
    title: string;
    author: Record<string, any>;
    slideshowUrl: string;
  }) {
    this.image = coverSlide.photoUrl;
    this.description = description;
    this.title = title;
    this.author = author;
    this.publicationDate = publicationDate;
    this.url = url;
  }

  toJSON(): SlideshowStructuredData {
    const data = {
      '@type': 'Article',
      '@id': 'article',
      datePublished: this.publicationDate,
      dateModified: this.publicationDate,
      description: this.description,
      headline: this.title,
      image: this.image,
      author: {
        '@type': 'Person',
        name: get(this.author, 'name'),
      },
      publisher: [
        {
          '@type': 'Organization',
          name: 'Autolist',
          logo: {
            '@type': 'ImageObject',
            url: logo,
            height: 60,
            width: 300,
          },
        },
      ],
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': this.url,
      },
    };

    return { ...defaults, ...data };
  }
}

export default Slideshow;
